import { render, staticRenderFns } from "./Disciplines.vue?vue&type=template&id=37eaf97d&scoped=true&"
import script from "./Disciplines.vue?vue&type=script&lang=js&"
export * from "./Disciplines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eaf97d",
  null
  
)

export default component.exports